import { Injectable, InjectionToken } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class UiServiceEnvironment {
  // API url
  private _apiUrl = '';
  set apiUrl(apiUrl: string)  {
    this._apiUrl = apiUrl;
  }
  get apiUrl(): string  {
    return(this._apiUrl);
  }

  private _payUrl = '';
  set payUrl(payUrl: string)  {
    this._payUrl = payUrl;
  }
  get payUrl(): string  {
    return(this._payUrl);
  }

  private _development = false;
  set development(development: boolean) {
    this._development = development;
  }
  get development(): boolean  {
    return(this._development);
  }

  private _log2Server = false;
  set log2Server(log2Server: boolean) {
    this._log2Server = log2Server;
  }
  get log2Server(): boolean  {
    return(this._log2Server);
  }

  private _enableDebug = false;
  set enableDebug(enableDebug: boolean) {
    this._enableDebug = enableDebug;
  }
  get enableDebug(): boolean  {
    return(this._enableDebug);
  }

  private _version = '';
  set version(version: string) {
    this._version = version;
  }
  get version(): string  {
    return(this._version);
  }

  private _assetsPath = 'assets';
  set assetsPath(assetsPath: string) {
    this._assetsPath = assetsPath;
  }
  get assetsPath(): string  {
    return(this._assetsPath);
  }

  constructor() { }
}

export const EnvironmentServiceFactory = () => {
  const env: {[index: string]: any} = new UiServiceEnvironment();

  const browserWindow: {[index: string]: any} = window || {};
  const browserWindowEnv = browserWindow['__env'] || {};

  // Assign environment variables from browser window
  for(const key in browserWindowEnv) {
    const keyName: string = key;
    if (browserWindowEnv.hasOwnProperty(key)) {
      env[keyName] = browserWindowEnv[key];
    }
  }

  return(env);
};

export const APP_NONCE = crypto.randomUUID();
export const CSP_TOKEN = new InjectionToken<string>('CSP Token');
export const EnvironmentNonceServiceFactory = (env: UiServiceEnvironment) => {
  const cspNonce = APP_NONCE;
  let monerisUrl = '';

  if (env.payUrl) {
    const url  = new URL(env.payUrl);
    monerisUrl = url.protocol + '//' + url.hostname;
  }

  let cspRules = `style-src 'self' https://cdn.jsdelivr.net https://fonts.googleapis.com ${monerisUrl} 'nonce-${cspNonce}';`;
     cspRules += `worker-src 'self' https://cdnjs.cloudflare.com blob:;`;
  document.querySelector('meta[http-equiv="Content-Security-Policy"]')?.setAttribute('content', cspRules);

  return cspNonce;
};
